import { useAuthStore } from "@/stores/auth-store";

// Canonical genesis client-role privileges, read from the access token's
// `resource_access.genesis.roles` and forwarded by the BFF. These mirror
// discovery's UserPrivilege.tryFromGenesisRole; genesis enforces them
// server-side. They gate the system-settings surface in the SPA.
export const Role = {
  WriteSystemSettings: "write:any:system-settings",
  WriteQuestionnaire: "write:any:questionnaire",
  WriteReferenceData: "write:any:reference-data",
  // Edit any Person's data. Deliberately NOT a SYSTEM_ROLE (holding it does not
  // grant the Systemeinstellungen surface — see roles.test.ts); it gates the
  // Roster import, which genesis's importCvBatch enforces server-side.
  WriteAnyPerson: "write:any:person",
} as const;

// Holding any of these grants access to the Systemeinstellungen surface.
const SYSTEM_ROLES: readonly string[] = [
  Role.WriteSystemSettings,
  Role.WriteQuestionnaire,
  Role.WriteReferenceData,
];

// Pure helpers (no React) so route guards and tests can call them directly.
export function hasRole(roles: string[] | undefined, role: string): boolean {
  return (roles ?? []).includes(role);
}

export function hasSystemAccess(roles: string[] | undefined): boolean {
  return (roles ?? []).some((r) => SYSTEM_ROLES.includes(r));
}

export function useHasRole(role: string): boolean {
  return useAuthStore((s) => hasRole(s.profile?.roles, role));
}

// True when the user holds any system-settings privilege. Drives whether the
// Systemeinstellungen entry point and its routes are shown at all.
export function useHasSystemAccess(): boolean {
  return useAuthStore((s) => hasSystemAccess(s.profile?.roles));
}
